import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const Bilty360Page = lazy(() => import("@/pages/reports.bilty-360.page"));

export const Route = createFileRoute("/reports/bilty-360")({
  component: Bilty360Page,
});
